import React from "react";
import { Box, Typography } from "@mui/material";

interface Props {
    vista: "usuarios" | "perfiles" | "permisos";
    setVista: React.Dispatch<
        React.SetStateAction<"usuarios" | "perfiles" | "permisos">
    >;
}

export default function MenuLateral({ vista, setVista }: Props) {

    const opciones = [
        {
            id: "usuarios",
            nombre: "Usuario",
        },
        {
            id: "permisos",
            nombre: "Permisos",
        },
        {
            id: "perfiles",
            nombre: "Perfiles",
        },
    ];

    const colores = {
        usuarios: "#1976D2",
        perfiles: "#F70083",
        permisos: "#EF7A11",
    };

    return (
        <Box
            sx={{
                width: 220,
                borderRight: "1px solid #D9D9D9",
                backgroundColor: "#FFFFFF",
                display: "flex",
                flexDirection: "column",
                py: 4,
            }}
        >
            {opciones.map((opcion) => (
                <Box
                    key={opcion.id}
                    onClick={() => setVista(opcion.id as any)}
                    sx={{
                        cursor: "pointer",
                        px: 4,
                        py: 3,
                        transition: ".25s",

                        backgroundColor:
                            vista === opcion.id
                                ? `${colores[opcion.id as keyof typeof colores]}15`
                                : "transparent",

                        borderLeft:
                            vista === opcion.id
                                ? `5px solid ${colores[opcion.id as keyof typeof colores]}`
                                : "5px solid transparent",

                        "&:hover": {
                            backgroundColor:
                                vista === opcion.id
                                    ? `${colores[opcion.id as keyof typeof colores]}15`
                                    : "#F8F8F8",
                        },
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "20px",
                            fontWeight: vista === opcion.id ? 700 : 500,
                            color:
                                vista === opcion.id
                                    ? colores[opcion.id as keyof typeof colores]
                                    : "#222",
                        }}
                    >
                        {opcion.nombre}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}